module.exports = __webpack_public_path__ + "static/img/200048.ccb5759c.png";